import { denormalize as _denormalize } from 'normalizr';

export const getEntities = (state, name) => state.entities[name];

export const getEntity = (state, name, id) => getEntities(state, name)[id];

export const denormalize = (state, data, schema) =>
  _denormalize(data, schema, state.entities);

export const denormalizeEntity = (state, name, id, schema) =>
  denormalize(state, getEntity(state, name, id), schema);
